
import mgPageData from "../../data/managedServices";

export default {
  data() {
    return {
      operationSystems: mgPageData.operationSystems,
      activeIndex: 1,
    };
  },
  methods: {},
};
